import React from "react";
import { RouteConfig } from "../Router";
import { PermissionType } from "amnShared/Permissions/IPermissions";

const StatisticsPage = React.lazy(
  () => import("amnShared/clinetAction/statistics/StatisticsPage"),
);
const DeliveryOrdersPage = React.lazy(
  () => import("amnShared/clinetAction/delivery/DeliveryOrdersPage"),
);
const PickupOrdersPage = React.lazy(
  () => import("amnShared/clinetAction/pickup/PickupOrdersPage"),
);

const UserProfile = React.lazy(() => import("amnShared/user/UserProfile"));
const FinishedTransaction = React.lazy(
  () => import("amnPos/action/finishedTransactions/FinishedTransaction"),
);
const RestMaterialsTransactions = React.lazy(
  () => import("amnRestaurants/materialsTransaction/RestMaterialsTransactions"),
);
const TransactionDetails = React.lazy(
  () =>
    import(
      "amnPos/action/finishedTransactions/TransactionDetails/TransactionDetails"
    ),
);
const ShiftSummaryRestPage = React.lazy(
  () => import("amnRestaurants/FrontEndReports/ShiftSummary/ShiftSummaryPage"),
);
const CalculatedCashDetailsRestPage = React.lazy(
  () =>
    import(
      "amnRestaurants/FrontEndReports/CalculatedCashDetails/CalculatedCashDetailsPage"
    ),
);
const CalculatedNonCashDetailsRestPage = React.lazy(
  () =>
    import(
      "amnRestaurants/FrontEndReports/CalculatedNonCashDetails/CalculatedNonCashDetails"
    ),
);
const MaterialsTransactionDetailsRestPage = React.lazy(
  () =>
    import(
      "amnRestaurants/FrontEndReports/MaterialsTransactionDetails/MaterialsTransactionDetailsPage"
    ),
);
const ExternalTransactionDetailsRestPage = React.lazy(
  () =>
    import(
      "amnRestaurants/FrontEndReports/ExternalTransactionDetails/ExternalTransactionDetailsPage"
    ),
);
const ShiftClosingDetailsRestPage = React.lazy(
  () =>
    import(
      "amnRestaurants/FrontEndReports/ShiftClosingDetails/ShiftClosingDetailsPage"
    ),
);
const FinishedOrdersDetails = React.lazy(
  () =>
    import(
      "amnPos/action/finishedOrders/fnishedOrderDetails/FinishedOrdersDetails"
    ),
);
const RestaurantsMainPage = React.lazy(
  () => import("amnRestaurants/RestaurantsMainPage"),
);
const RestDeliverPickUpOrderPage = React.lazy(
  () =>
    import(
      "amnRestaurants/materialsTransaction/workingArea/DeliverPickUpOrderPage/RestDeliverPickUpOrderPage"
    ),
);

const CustomerStatementRestaurantReport = React.lazy(
  () =>
    import("amnRestaurants/FrontEndReports/CustomerStatementRestaurantReport"),
);
const EditClientPage = React.lazy(
  () => import("amnShared/clients/EditClientPage"),
);
const SettleDeliveryPaymentsPage = React.lazy(
  () =>
    import(
      "amnShared/DriverManagement/SettleDeliveryPaymentsPage/SettleDeliveryPaymentsPage"
    ),
);
const ShiftsAndExternalsPage = React.lazy(
  () => import("amnPos/shiftsAndExternals/ShiftsAndExternalsPage"),
);
const OrderManagementPage = React.lazy(
  () => import("amnShared/orderManagement/OrderManagementPage"),
);
const DriverManagementPage = React.lazy(
  () =>
    import(
      "amnShared/DriverManagement/DriverManagementPage/DriverManagementPage"
    ),
);
const DeliveryTripSettlementPage = React.lazy(
  () =>
    import(
      "amnShared/DriverManagement/DeliveryTripSettlementPage/DeliveryTripSettlementPage"
    ),
);
const DeliveryStartTripPassingDriverPage = React.lazy(
  () =>
    import(
      "amnShared/DriverManagement/DeliveryStartTripPassingDriverPage/DeliveryStartTripPassingDriverPage"
    ),
);
const DriverReport = React.lazy(
  () => import("amnShared/Reports/DriverReport/DriverReport"),
);
const TripDetailsReport = React.lazy(
  () => import("amnShared/Reports/TripDetailsReport/TripDetailsReport"),
);
const OtherInformationspage = React.lazy(
  () =>
    import(
      "amnShared/orderManagement/ordersEventHistory/OrderEventHistoryPage"
    ),
);
const FinishedOrders = React.lazy(
  () => import("amnPos/action/finishedOrders/FinishedOrders"),
);
const restaurantRoutes = (helpers: {
  getPath: any;
  LoggedInRest: any;
  getClientPagePermissions: any;
  RouterNavigateType: any;
}): RouteConfig => ({
  path: helpers.getPath("/restaurants"),
  element: helpers.LoggedInRest(<RestaurantsMainPage />),
  children: [
    {
      path: helpers.getPath("/restaurants/statistics-client/:id"),
      element: helpers.LoggedInRest(<StatisticsPage />),
    },
    {
      path: helpers.getPath("/restaurants/delivery-client/:id"),
      element: helpers.LoggedInRest(<DeliveryOrdersPage />),
    },
    {
      path: helpers.getPath("/restaurants/pickup-client/:id"),
      element: helpers.LoggedInRest(<PickupOrdersPage />),
    },
    { path: "", element: helpers.LoggedInRest(<RestMaterialsTransactions />) },
    {
      path: helpers.getPath("/restaurants/shiftsAndExternals"),
      element: helpers.LoggedInRest(<ShiftsAndExternalsPage />),
    },
    {
      path: helpers.getPath("/restaurants/OrderManagement"),
      element: helpers.LoggedInRest(
        <OrderManagementPage />,
        PermissionType.CanUseOrderManagementTab,
      ),
    },
    {
      path: helpers.getPath("/restaurants/driverManagementPage"),
      element: helpers.LoggedInRest(
        <DriverManagementPage />,
        PermissionType.CanUseDeliveryOrdersManagement,
      ),
    },
    {
      path: helpers.getPath("/restaurants/deliveryTripSettlementPage/:id"),
      element: helpers.LoggedInRest(
        <DeliveryTripSettlementPage />,
        PermissionType.CanSettleDeliveryTrip,
      ),
    },
    {
      path: helpers.getPath(
        "/restaurants/deliveryStartTripPassingDriverPage/:id",
      ),
      element: helpers.LoggedInRest(<DeliveryStartTripPassingDriverPage />),
    },
    {
      path: helpers.getPath("/restaurants/driverReport/:id"),
      element: helpers.LoggedInRest(<DriverReport />),
    },
    {
      path: helpers.getPath("/restaurants/tripDetailsReport/:id"),
      element: helpers.LoggedInRest(<TripDetailsReport />),
    },
    {
      path: helpers.getPath("/restaurants/settleDeliveryPaymentsPage"),
      element: helpers.LoggedInRest(<SettleDeliveryPaymentsPage />),
    },
    {
      path: helpers.getPath(
        "/restaurants/OrderManagement/OrdersEventHistory/:id/:delivery",
      ),
      element: helpers.LoggedInRest(<OtherInformationspage />),
    },
    {
      path: helpers.getPath("/restaurants/shiftSummary/:id"),
      element: helpers.LoggedInRest(
        <ShiftSummaryRestPage />,
        PermissionType.CanViewShiftDigest,
      ),
    },
    {
      path: helpers.getPath("/restaurants/calculatedCashDetails/:id"),
      element: helpers.LoggedInRest(
        <CalculatedCashDetailsRestPage />,
        PermissionType.CanViewCalculatedCashDetails,
      ),
    },
    {
      path: helpers.getPath("/restaurants/calculatedNonCashDetails/:id"),
      element: helpers.LoggedInRest(
        <CalculatedNonCashDetailsRestPage />,
        PermissionType.CanViewCalculatedNonCashDetails,
      ),
    },
    {
      path: helpers.getPath("/restaurants/materialsTransactionDetails/:id"),
      element: helpers.LoggedInRest(
        <MaterialsTransactionDetailsRestPage />,
        PermissionType.CanViewMaterialsAndServicesTransactionsDetail,
      ),
    },
    {
      path: helpers.getPath("/restaurants/externalTransactionDetails/:id"),
      element: helpers.LoggedInRest(
        <ExternalTransactionDetailsRestPage />,
        PermissionType.CanViewExternalTransactionsDetails,
      ),
    },
    {
      path: helpers.getPath("/restaurants/shiftClosingDetails/:id"),
      element: helpers.LoggedInRest(
        <ShiftClosingDetailsRestPage />,
        PermissionType.CanViewClosingDetails,
      ),
    },
    {
      path: helpers.getPath("/restaurants/materialsTransactions"),
      element: helpers.LoggedInRest(<RestMaterialsTransactions />),
    },
    {
      path: helpers.getPath("/restaurants/finished-orders"),
      element: helpers.LoggedInRest(<FinishedOrders />),
    },
    {
      path: helpers.getPath("/restaurants/finished-orders/:id"),
      element: helpers.LoggedInRest(<FinishedOrdersDetails />),
    },
    {
      path: helpers.getPath("/restaurants/materialsTransactions/finished"),
      element: helpers.LoggedInRest(
        <FinishedTransaction />,
        PermissionType.ViewSettledTransactions,
      ),
    },
    {
      path: helpers.getPath("/restaurants/materialsTransactions/finished/:id"),
      element: helpers.LoggedInRest(<TransactionDetails />),
    },
    {
      path: helpers.getPath("/restaurants/restDeliverPickUpOrderPage/:id"),
      element: helpers.LoggedInRest(
        <RestDeliverPickUpOrderPage />,
        PermissionType.CanSettlePickupOrder,
      ),
    },
    {
      path: helpers.getPath("/restaurants/customer-statement-report/:id"),
      element: helpers.LoggedInRest(
        <CustomerStatementRestaurantReport />,
        PermissionType.CanViewCustomerBalanceStatement,
      ),
    },
    {
      path: helpers.getPath("/restaurants/user-profile"),
      element: helpers.LoggedInRest(
        <UserProfile navigateTo={helpers.RouterNavigateType.Restaurant} />,
      ),
    },
    {
      path: helpers.getPath("/restaurants/create-client"),
      element: helpers.LoggedInRest(
        <EditClientPage
          navigateTo={helpers.RouterNavigateType.Restaurant}
          permissions={helpers.getClientPagePermissions()}
        />,
        PermissionType.CanAddNewClient,
      ),
    },
    {
      path: helpers.getPath("/restaurants/edit-client/:id"),
      element: helpers.LoggedInRest(
        <EditClientPage
          navigateTo={helpers.RouterNavigateType.Restaurant}
          permissions={helpers.getClientPagePermissions()}
        />,
        PermissionType.CanModifyExistingClient,
      ),
    },
    { path: "*", element: <div>Invalid route</div> },
  ],
});

export default restaurantRoutes;
